import { Component, Input } from '@angular/core';
import { ZoningCode } from 'src/app/modules/instance/models';
import { InstanceService, TaskService, ZoningCodeService } from 'src/app/modules/instance/services';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { filter, switchMap } from 'rxjs/operators';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { ZoningCodeReindexButtonComponent } from '../zoning-code-reindex-button/zoning-code-reindex-button.component';

@Component({
    standalone: false,
    selector: 'app-zoning-code-reindex-with-cursor-button',
    templateUrl: './zoning-code-reindex-with-cursor-button.component.html',
    styleUrls: ['./zoning-code-reindex-with-cursor-button.component.scss']
})
export class ZoningCodeReindexWithCursorButtonComponent extends ZoningCodeReindexButtonComponent {
    constructor(
        protected readonly zoningCodeService: ZoningCodeService,
        protected readonly instanceService: InstanceService,
        protected readonly dialog: MatDialog,
        protected readonly taskService: TaskService
    ) {
        super(zoningCodeService, instanceService, dialog, taskService);
    }

    @Input()
    zoningCode: ZoningCode;

    @Input()
    task: ITaskModel;

    reindexZoningCode(event: Event) {
        event.stopPropagation();
        const indexingTask = this.getIndexingTask();

        if (!indexingTask) {
            this.openIndexZCPropertyRecordsTaskDialog().subscribe(indexingTasParams => {
                if (!indexingTasParams) {
                    return;
                }
                this.zoningCodeService.indexZCPropertyRecordsWithCursor({
                    ...indexingTasParams,
                    instance: this.instance,
                    zoningCodeId: this.zoningCode.Id,
                    zcGridicsId: this.zoningCode.GridicsId
                });
            });
            return;
        }

        this.openReindexZCPropertyRecordsDialog(this.zoningCode, indexingTask);
    }

    openReindexZCPropertyRecordsDialog(_zoningCode: ZoningCode, indexingTask: ITaskModel) {
        const dialogConfig = new MatDialogConfig();

        const title = 'Start reindexing';

        const topContent = 'Indexing is in process.',
            bottomContent = 'Do you want to stop it and start improved reindexing?',
            okButtonColor = 'warn';

        dialogConfig.autoFocus = true;
        dialogConfig.data = { title, topContent, bottomContent, okButtonColor };
        this.dialog
            .open(ConfirmationDialogComponent, dialogConfig)
            .afterClosed()
            .pipe(
                filter(isConfirm => isConfirm),
                switchMap(() => this.taskService.deleteTask(indexingTask)),
                switchMap(() => this.openIndexZCPropertyRecordsTaskDialog()),
                filter(indexingTasParams => indexingTasParams)
            )
            .subscribe(indexingTasParams => {
                if (!indexingTasParams) {
                    return;
                }
                this.zoningCodeService.indexZCPropertyRecordsWithCursor({
                    ...indexingTasParams,
                    instance: this.instance,
                    zoningCodeId: this.zoningCode.Id,
                    zcGridicsId: this.zoningCode.GridicsId
                });
            });
    }
}
